<template>
  <div>
    <div class="bottom">
      <div class="bottombox" style="display: block">
        <div v-show="false" class="erweicode">
          <div class="codebox">
            <img src="@/assets/erweicode.jpg" />
          </div>
          <span>微信公众号</span>
        </div>
        <div class="bt bt01">
          <p>
            精诚为医（北京）技术有限公司 <br />
            企业地址：北京市房山区怡和北路5号院&nbsp;&nbsp;&nbsp;&nbsp;联系电话：18931158707
          </p>
          <span>
            Copyright © 2020 精诚为医（北京）技术有限公司 版权所有 技术支持 &nbsp;&nbsp;&nbsp;&nbsp;京ICP备：
            <a class="icp" href="https://beian.miit.gov.cn/"> 20014566号</a>

            <a
              target="_blank"
              class="beian"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011102002283"
              ><img src="@/assets/beian.png" style="float: left" />
              <span style="float: left"> 京公网安备 11011102002283号 </span></a
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.bottom {
  background: #303030;
  width: 100%;
}
.bottom .bottombox {
  width: 1170px;
  margin: 0 auto;
  padding: 35px 15px;
  overflow: hidden;
}
.bt {
  float: left;
}
.bt01 {
  width: 785px;
}
.bt h5 {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
}
.bt .redline {
  width: 34px;
  border-top: 3px solid #ff0000;
  margin-top: 18px;
}
.bt p {
  margin-top: 20px;
  line-height: 30px;
  color: #ccc;
}
.bt01 span {
  line-height: 30px;
  color: #888;
  font-size: 14px;
}
.bt01 span a {
  line-height: 30px;
  color: #888;
  font-size: 14px;
}

.bt01 span a.beian {
  line-height: 30px;
  color: #888;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.bt01 span a:hover {
  color: rgb(0, 128, 255);
  text-decoration: underline;
}

.bt01 span a:hover span {
  color: rgb(0, 128, 255);
  text-decoration: underline;
}

.link {
  padding-top: 15px;
}
.link a {
  display: block;
  margin-top: 12px;
  color: #ccc;
}
.bt02 {
  margin-left: 40px;
  width: 170px;
}
.bt04 {
  margin-left: 40px;
}
.copyright {
  display: block;
  border-top: 1px solid #363636;
  text-align: center;
  padding: 35px 0;
  color: #ccc;
}

.erweicode {
  float: right;
  text-align: center;
}
.codebox {
  width: 90px;
  padding: 7px;
  border: 1px solid #575757;
}
.codebox img {
  display: block;
  width: 90px;
}
.erweicode span {
  font-size: 12px;
  color: #fff;
}
</style>
